// extracted by mini-css-extract-plugin
export default {"container":"OrderList_container__kvbi+","title":"OrderList_title__xKPV3"};